
import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    // Home page latest recipes section
    {
        const LATEST = document.querySelector('.home-latest')
        if(!LATEST || LATEST.length < 1) return

        const header = LATEST.querySelector('.latest-title')
        const content = LATEST.querySelector('.latest-content')
        const categories = LATEST.querySelectorAll('.recipe-categories a')
        const slides = LATEST.querySelectorAll('.link-card')

        let timeline = gsap.timeline({
            duration: 0.5,
            ease: "power2.inOut",
            scrollTrigger: {
                trigger: LATEST,
                start: 'top bottom'
            }
        })

        timeline.to([header, content], { stagger: 0.1, opacity: 1, translateY: 0 })
            .addLabel('header-content')
            .to(categories, { stagger: {
                each: 0.1,
                from: 'random',
                grid: "auto"
            }, opacity: 1, scale: 1 }, "<")
            .addLabel('categories')
            .to(slides, { stagger: 0.1, opacity: 1 }, "<")
            .addLabel('slider')
    }

    {
        const CATEGORIES = document.querySelector('.HomePage .home-product-categories')
        if(!CATEGORIES) return

        const cards = CATEGORIES.querySelectorAll('.product-card')

        let timeline = gsap.timeline({
            duration: 1,
            ease: "power2.inOut",
            scrollTrigger: {
                trigger: CATEGORIES,
                start: 'top bottom'
            }
        })

        timeline.to(cards, { stagger: {
            each: 0.1,
            from: 'random',
            grid: "auto"
        }, opacity: 1 })
    }

    {
        const INSTA = document.querySelector('.follow-strip--insta')
        if(!INSTA) return

        let timeline = gsap.timeline({
            scrollTrigger: {
                trigger: INSTA,
                start: "top 50%",
            }
        })

        timeline.to(INSTA, { rotate: 3, duration: .1, ease: "elastic.out(1, 0.3)" })
            .to(INSTA, { rotate: -3, duration: .1, ease: "elastic.out(1, 0.3)" })
            .to(INSTA, { rotate: 0, duration: .1, ease: "elastic.out(1, 0.3)" })

    }
}
